import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
//
const Status = styled.div`
  border: 1px solid currentColor;
  font-size: 0.8rem;
  margin: 0 auto 1rem;
  padding: 1rem;
  position: relative;
`;

const Progress = styled.div`
  background-color: rgba(0, 0, 0, 0.25);
  bottom: 0;
  display: block;
  height: 100%;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: ${props =>
    props.uploadPercentage ? `${props.uploadPercentage}%` : "0%"};
`;

const Message = styled.span`
  position: relative;
  z-index: 10;
`;

const CouImageUploaderStatus = props => (
  <Status uploadPercentage={props.uploadPercentage}>
    <Message>
      {props.uploadMessage}: {props.uploadPercentage}% {props.uploading}
    </Message>
  </Status>
);

CouImageUploaderStatus.propTypes = {
  uploading: PropTypes.string.isRequired,
  uploadMessage: PropTypes.string.isRequired,
  uploadPercentage: PropTypes.number.isRequired
};

export default CouImageUploaderStatus;
